import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModernFooter',
  setup(__props) {

const getters = store?.getters;

const footerLinks = computed(() => getters.getFooterLinks);
const copyright = computed(() => getters.getCopyright);
const voucherPartner = computed(() => getters?.getVoucherPartner);

return { __sfc: true,getters, footerLinks, copyright, voucherPartner }
}

})